
<div class="ui-g-12 ui-md-6 visually-hidden">
	<label [attr.data-resource-identifier]="field.formControl.value">
		{{field.formControl.value}}
	</label>
</div>